import React from 'react';
import { FadeIn } from '../animations/FadeIn';
import { WaveGraphic } from '../graphics/WaveGraphic';
import { PhoneMockup } from '../graphics/PhoneMockup';
import SafeIcon from '../../common/SafeIcon';

export const Hero = () => {
  return (
    <section className="relative bg-ink min-h-[90vh] flex items-center pt-24 pb-20 overflow-hidden rounded-b-[40px]">
      <WaveGraphic className="top-1/4 left-0" />
      
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center relative z-10 w-full">
        <div className="max-w-xl">
          <FadeIn>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-mint text-xs font-bold tracking-widest uppercase mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-mint"></span>
              Coming Soon
            </div>
            <h1 className="text-5xl md:text-6xl font-semibold text-white tracking-tight leading-[1.1] mb-6">
              Stay on track with your <span className="text-transparent bg-clip-text bg-wave-gradient">GLP-1 journey.</span>
            </h1>
          </FadeIn>
          
          <FadeIn delay={0.1}>
            <p className="text-lg md:text-xl text-white/70 leading-relaxed mb-10 font-light">
              Curve helps you log doses, track weight, manage side effects, and stay consistent — privately, on your phone.
            </p>
          </FadeIn>
          
          <FadeIn delay={0.2} className="flex flex-col sm:flex-row gap-4">
            <div className="relative group">
              <button className="w-full flex items-center justify-center gap-3 bg-white/10 text-white/40 px-6 py-3.5 rounded-full font-semibold cursor-not-allowed border border-white/10">
                <SafeIcon name="Apple" className="text-xl" />
                App Store
              </button>
              <span className="absolute -top-2 -right-2 bg-mint text-ink text-[10px] font-bold px-2 py-0.5 rounded-full shadow-lg">SOON</span>
            </div>
            <div className="relative group">
              <button className="w-full flex items-center justify-center gap-3 bg-white/10 text-white/40 px-6 py-3.5 rounded-full font-semibold cursor-not-allowed border border-white/10">
                <SafeIcon name="Play" className="text-xl" />
                Google Play
              </button>
              <span className="absolute -top-2 -right-2 bg-sky text-ink text-[10px] font-bold px-2 py-0.5 rounded-full shadow-lg">SOON</span>
            </div>
          </FadeIn>
          
          <FadeIn delay={0.3} className="mt-8">
            <p className="text-white/40 text-sm font-light italic">
              * Curve is currently in private beta. Public release coming soon.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} direction="left" className="relative">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-wave-gradient rounded-full blur-[100px] opacity-30"></div>
          <PhoneMockup />
        </FadeIn>
      </div>
    </section>
  );
};